// export this package's api
import Trigger from './src/';
export default Trigger;



// WEBPACK FOOTER //
// ./_rc-trigger-1.11.4/index.js